import React from 'react';
import { classnames } from '../../lib';
export const ScrollContainer = ({ children, className, innerRef }) => {
    return (React.createElement("div", { ref: innerRef, className: classnames('scroll-container', className) }, children));
};
//# sourceMappingURL=ScrollContainer.js.map